'use strict';

module.exports = strikethrough;
var tilde = '~';
var fence = tilde + tilde;

function strikethrough(node) {
  return fence + this.all(node).join('') + fence;
}